import { ENTITY } from '../constant';
import { CLIENT, PUBLIC_CLIENT_SOFTWARE, SOFTWARE } from '../constant/actionTypes';
import { dateFormat } from '../helper/StringUtils';
import { httpservice } from '../services';
import { constants } from '../constant/constant';

let apiEndPoint = constants.ADMIN_URL;
const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;

if (loginUser) {
  if (loginUser.role.roleName === 'client') {
    apiEndPoint = constants.CLIENT_URL;
  }
}

export const getSoftwareListForClient = () => (dispatch) => {
  const query = `${constants.API.SOFTWARE}`;

  dispatch({
    payload: [],
    type: PUBLIC_CLIENT_SOFTWARE.GET.INITIATE,
  });
  return httpservice()
    .get(query)
    .then((response) => {
      const {
        rows = [],
        count = 0,
      } = response.data.response;
      const softwareIdArray = [];
      const responseData = rows.map((data) => {
        if (data.clientId) {
          if (softwareIdArray.includes(data.softwareId)) {
            return undefined;
          }
          softwareIdArray.push(data.softwareId);
          return ({
            id: data.softwareId,
            submoduleId: data.submoduleId,
            name: data.software.name,
            description: data.software.description,
            guid: data.software.guid,
          });
        }
        return data;
      });

      const dataArray = responseData.filter((element) => typeof (element) !== 'undefined');
      dispatch({
        payload: {
          data: dataArray,
          count,
        },
        type: PUBLIC_CLIENT_SOFTWARE.GET.SUCCESS,
      });
      return {
        data: dataArray,
        count,
      };
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: PUBLIC_CLIENT_SOFTWARE.GET.ERROR,
      });
    });
};

export const doClientSoftwareCreate = (data) => httpservice()
  .post(`${apiEndPoint}${constants.API.SOFTWARE_VERSION_INSTALL}`, data)
  .then((response) => ({ status: 1, data: response.data }))
  .catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));

export const getClientSoftwaresList = (id) => (dispatch) => {
  dispatch({
    payload: [],
    type: CLIENT.SOFTWARES.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.CLIENT_SOFTWARE}/${id}`)
    .then((response) => {
      dispatch({
        payload: response.data.response,
        type: CLIENT.SOFTWARES.SUCCESS,
      });
      return response.data.response;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: CLIENT.SOFTWARES.ERROR,
      });
    });
};

export const doUpdateClientSoftwares = (softwareInfo) => httpservice()
  .post(`${constants.API.CLIENT_SOFTWARE}`, { softwares: softwareInfo })
  .then((response) => response.data)
  .catch((error) => (error.response && error.response.data ? error.response.data : error));

export const getClientSoftwareSubmodulesList = (id) => (dispatch) => {
  dispatch({
    payload: [],
    type: CLIENT.SOFTWARE_SUBMODULES.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.CLIENT_SOFTWARE_SUBMODULE}/${id}`)
    .then((response) => {
      dispatch({
        payload: response.data.response,
        type: CLIENT.SOFTWARE_SUBMODULES.SUCCESS,
      });
      return response.data.response;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: CLIENT.SOFTWARE_SUBMODULES.ERROR,
      });
    });
};

export const doUpdateClientSoftwareSubmodule = async (softwaresData, submodulesData) => {
  try {
    const response = await httpservice()
      .post(`${constants.API.CLIENT_SOFTWARE_SUBMODULE}`, { softwares: softwaresData, submodules: submodulesData });

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getClientSoftwareInstalledList = (id) => (dispatch) => {
  const url = constants.API.CLIENT_SOFTWARE_VERSION.replace(ENTITY.CLIENT_ID, id);

  dispatch({
    payload: [],
    type: CLIENT.SOFTWARES_INSTALLED_LIST.INITIATE,
  });

  return httpservice()
    .get(url)
    .then((response) => {
      const softwareList = response.data.response.map((softwareListData) => {
        if (softwareListData.version) {
          return ({
            id: softwareListData.id,
            clientId: softwareListData.clientId,
            createdAt: softwareListData.createdAt,
            softwareName: softwareListData.software.name,
            softwareId: softwareListData.softwareId,
            submoduleName: softwareListData.submodule,
            submoduleId: softwareListData.submoduleId,
            versionName: softwareListData.version.versionNumber,
            isLatest: softwareListData.version.isLatest,
            version: softwareListData.version,
            platform: (softwareListData.version.platform).charAt(0).toUpperCase() + (softwareListData.version.platform).slice(1),
            architecture: softwareListData.version.architecture,
            versionId: softwareListData.version.id,
            software: softwareListData.software,
          });
        }

        return ({
          id: softwareListData.id,
          clientId: softwareListData.clientId,
          createdAt: softwareListData.createdAt,
          softwareName: softwareListData.software.name,
          softwareId: softwareListData.softwareId,
          submoduleName: softwareListData.submodule.name,
          submoduleId: softwareListData.submoduleId,
          versionName: softwareListData.submoduleVersion.versionNumber,
          isLatest: softwareListData.submoduleVersion.isLatest,
          version: softwareListData.submoduleVersion,
          platform: (softwareListData.submoduleVersion.platform).charAt(0).toUpperCase() + (softwareListData.submoduleVersion.platform).slice(1),
          architecture: softwareListData.submoduleVersion.architecture,
          versionId: softwareListData.submoduleVersion.id,
          software: softwareListData.software,
        });
      });

      dispatch({
        payload: softwareList,
        type: CLIENT.SOFTWARES_INSTALLED_LIST.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: CLIENT.SOFTWARES_INSTALLED_LIST.ERROR,
      });
    });
};

export const getClientAdminSoftwaresList = (object) => (dispatch) => {
  const query = `${constants.API.CLIENT_MODULE_SOFTWARE}/${object.id}`;
  dispatch({
    payload: [],
    type: SOFTWARE.GET.INITIATE,
  });
  return httpservice()
    .get(query)
    .then((response) => {
      const softwareData = response.data.response;

      const finalData = softwareData.map((data) => (
        { ...data, expiryDate: dateFormat(data.expiryDate) }
      ));

      dispatch({
        payload: { data: finalData, count: finalData.length },
        type: SOFTWARE.GET.SUCCESS,
      });
      return { data: finalData, count: finalData.length };
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SOFTWARE.GET.ERROR,
      });
    });
};
